var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrestaciones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512.002 512.002"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88B337"
    },
    d: "M423.622,332.518c0.009-3.866-1.059-7.652-3.089-10.944l-19.681-31.683 c-2.453-4.872-3.724-10.255-3.707-15.709v-97.61c0-63.367-51.364-114.731-114.731-114.731h-52.953 c-63.367,0-114.731,51.364-114.731,114.731v97.61c0.018,5.454-1.253,10.838-3.707,15.709l-19.681,31.683 c-2.03,3.292-3.098,7.078-3.089,10.944l0,0c0.044,11.341,9.223,20.519,20.563,20.563h294.241 C414.399,353.037,423.578,343.858,423.622,332.518z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#88B337"
    },
    points: "282.415,61.841 326.542,0.063 185.335,0.063 229.462,61.841 229.462,79.492 282.415,79.492  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B962A"
    },
    d: "M420.533,321.574l-19.681-31.683c-2.453-4.872-3.724-10.255-3.707-15.709v-97.61 c0.062-25.559-8.419-50.411-24.093-70.604C349.488,235.791,266.529,310.631,188.6,353.081h214.459 c11.402,0.044,20.687-9.161,20.731-20.572c0.018-3.866-1.05-7.652-3.08-10.935H420.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.065,194.223v-5.648c-0.044-16.354-13.3-29.609-29.654-29.654h-5.648V141.27h-17.651v17.651 h-5.648c-16.38-0.053-29.698,13.176-29.751,29.556c-0.044,12.435,7.678,23.573,19.337,27.897l16.062,6.001v33.625h-5.648 c-6.628,0-12.003-5.375-12.003-12.003l0,0v-5.648h-17.651v5.648c0.044,16.354,13.3,29.609,29.654,29.654h28.948 c16.38,0.053,29.698-13.176,29.751-29.556c0.044-12.435-7.678-23.573-19.337-27.897l-16.062-6.001v-33.625h5.648 c6.628,0,12.003,5.375,12.003,12.003l0,0v5.648H300.065z M274.648,232.702c4.66,1.809,7.74,6.293,7.766,11.297 c0,6.628-5.375,12.003-12.003,12.003l0,0h-5.648v-27.006L274.648,232.702z M247.113,203.578l-9.885-3.707 c-4.66-1.809-7.74-6.293-7.766-11.297c0-6.628,5.375-12.003,12.003-12.003l0,0h5.648V203.578z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB62F"
    },
    d: "M432.447,88.317L432.447,88.317c-3.001-18.11-17.192-32.301-35.302-35.302l0,0 c18.11-3.001,32.301-17.192,35.302-35.302l0,0c3.001,18.11,17.192,32.301,35.302,35.302l0,0 C449.639,56.016,435.448,70.208,432.447,88.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB62F"
    },
    d: "M35.302,264.826L35.302,264.826C32.301,246.717,18.11,232.525,0,229.525l0,0 c18.11-3.001,32.301-17.192,35.302-35.302l0,0c3.001,18.11,17.192,32.301,35.302,35.302l0,0 C52.494,232.525,38.302,246.717,35.302,264.826z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC9A3"
    },
    d: "M508.081,307.983c-7.246-12.197-22.814-16.512-35.302-9.796l-125.233,53.482 c-2.206,0.935-4.58,1.421-6.972,1.412h-155.24c-9.752,0-17.651-7.899-17.651-17.651c0-9.752,7.899-17.651,17.651-17.651h70.604 c29.248,0,52.953-23.705,52.953-52.953H162.035c-24.341,0.018-47.357,11.094-62.572,30.095l-55.336,66.985l62.308,114.201 l239.788-57.63c10.361-2.392,20.387-6.063,29.83-10.944l123.556-63.279C511.903,336.533,515.68,320.356,508.081,307.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BB8F"
    },
    d: "M86.578,439.747l19.857,36.361l239.788-57.63c10.361-2.392,20.387-6.063,29.83-10.944l66.809-34.331 C331.837,407.181,184.452,428.362,86.578,439.747z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4398D1"
    },
    points: "0,353.081 0,511.939 114.731,511.939 141.207,485.463 35.302,326.605 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E8CC7"
    },
    d: "M0,511.939h114.731l26.476-26.476l-19.416-29.124C82.536,472.542,41.727,484.695,0,492.612V511.939z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D9D9D9"
    },
    cx: 79.429,
    cy: 467.838,
    r: 17.651
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrestaciones);
export default __webpack_public_path__ + "static/media/prestaciones.6191230a55fd6faec55e53e124086036.svg";
export { ForwardRef as ReactComponent };